import { Aurelia, PLATFORM } from 'aurelia-framework';

export function configure(aurelia: any) {
    aurelia
        .globalResources(PLATFORM.moduleName("./blur-on-enter"))
        .globalResources(PLATFORM.moduleName("./clipboard"))
        .globalResources(PLATFORM.moduleName("./mdx-no-collapse"));

}